module.exports = __webpack_public_path__ + "static/assets/dbfb671fc8821cb53cc642d2a2e8c973.svg";